import * as React from "react";
import { cn } from "@/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input"> & {
  variant?: "default" | "glass" | "outlined";
}>(({ className, type, variant = "default", ...props }, ref) => {
  const baseClasses = "flex h-11 w-full rounded-lg px-4 py-2 text-sm transition-all duration-300 ease-out file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50";
  
  const variantClasses = {
    default: "border border-input bg-background ring-offset-background focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 hover:border-primary/50 focus:border-primary",
    glass: "border border-white/20 bg-white/10 backdrop-blur-sm ring-offset-background focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:ring-offset-2 hover:bg-white/20 focus:bg-white/20",
    outlined: "border-2 border-primary/20 bg-transparent ring-offset-background focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 hover:border-primary/40 focus:border-primary",
  };
  
  return (
    <input
      type={type}
      className={cn(
        baseClasses,
        variantClasses[variant],
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = "Input";

export { Input };
